export default __webpack_public_path__ + "static/media/exif.7f7a4b71.svg";